/* eslint-disable no-barrel-files/no-barrel-files */
/**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */

export type {
	UserAndGroupSearchQuery$data as UserAndGroupSearchQuery,
	UserAndGroupSearchQuery$variables as UserAndGroupSearchQueryVariables,
} from '../__generated__/UserAndGroupSearchQuery.graphql.ts';

// Nested types extracted from Relay-generated types
import type { UserAndGroupSearchQuery$data } from '../__generated__/UserAndGroupSearchQuery.graphql.ts';
export type UserAndGroupSearchQuery_userGroupSearch_GraphQLUserAndGroupSearchResults_users_Anonymous = NonNullable<NonNullable<UserAndGroupSearchQuery$data['userGroupSearch']>['users']>;
export type UserAndGroupSearchQuery_userGroupSearch_GraphQLUserAndGroupSearchResults_users_KnownUser = NonNullable<NonNullable<UserAndGroupSearchQuery$data['userGroupSearch']>['users']>;
export type UserAndGroupSearchQuery_userGroupSearch_GraphQLUserAndGroupSearchResults_users_UnknownUser = NonNullable<NonNullable<UserAndGroupSearchQuery$data['userGroupSearch']>['users']>;
export type UserAndGroupSearchQuery_userGroupSearch_GraphQLUserAndGroupSearchResults_users_User = NonNullable<NonNullable<UserAndGroupSearchQuery$data['userGroupSearch']>['users']>;
export type UserAndGroupSearchQuery_userGroupSearch_GraphQLUserAndGroupSearchResults_users = NonNullable<NonNullable<UserAndGroupSearchQuery$data['userGroupSearch']>['users']>;
export type UserAndGroupSearchQuery_userGroupSearch_GraphQLUserAndGroupSearchResults_groups_Group = NonNullable<NonNullable<UserAndGroupSearchQuery$data['userGroupSearch']>['groups']>;
export type UserAndGroupSearchQuery_userGroupSearch_GraphQLUserAndGroupSearchResults = NonNullable<UserAndGroupSearchQuery$data['userGroupSearch']>;

// GraphQL enums (preserved from original file)
// ⚠️  DEPRECATION WARNING: Prefer using Relay's generated union string types instead of enums.
// Relay generates more type-safe union types (e.g., "DRAFT" | "PUBLISHED" | "ARCHIVED")
// instead of enums. These enums are kept for backward compatibility only.
export enum SitePermissionType {
  ANONYMOUS = "ANONYMOUS",
  APP = "APP",
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
  JSD = "JSD",
}

export enum SitePermissionTypeFilter {
  ALL = "ALL",
  EXTERNALCOLLABORATOR = "EXTERNALCOLLABORATOR",
  NONE = "NONE",
}

